import styled from 'styled-components';
import media from '../../../../constants/media';

export const FormWrapper = styled.div`
display: flex;
flex-wrap: wrap;
margin-bottom: 1rem;

${media.mobileAndTabletOnly`
 flex-direction: column;
  `}
`;

export const CheckBoxWrapper = styled.div`
padding: 1rem;
width: max-content;
`;

export const FieldWrapper = styled.div`
padding: 1rem;
display: flex;
flex-direction: column;
flex-basis: 50%;
`